import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Active company header — injected on every request when set.
let _activeCompanyId = null;

export function setActiveCompanyId(id) {
  _activeCompanyId = id || null;
  try {
    if (id) localStorage.setItem("serp_active_company", id);
    else localStorage.removeItem("serp_active_company");
  } catch { /* ignore */ }
}

export function getActiveCompanyId() {
  if (_activeCompanyId) return _activeCompanyId;
  try {
    _activeCompanyId = localStorage.getItem("serp_active_company") || null;
  } catch { /* ignore */ }
  return _activeCompanyId;
}

api.interceptors.request.use((config) => {
  const cid = getActiveCompanyId();
  if (cid && !config.headers["X-Company-Id"]) {
    config.headers["X-Company-Id"] = cid;
  }
  return config;
});

// If a JWT holder becomes pending / disabled between requests (Super Admin
// flipped their status), the next authenticated call returns 403 with a
// "pending approval" body. Redirect them to /login so they can't sit on a
// stale, half-loaded workspace.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err?.response?.data?.detail;
    const status = err?.response?.status;
    const isAuthEndpoint = (err?.config?.url || "").includes("/auth/");
    if (status === 403 && typeof detail === "string" && /pending approval|has been disabled/i.test(detail) && !isAuthEndpoint) {
      try { localStorage.removeItem("serp_active_company"); } catch { /* ignore */ }
      // Race-safe redirect — don't loop if we're already on /login.
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login?gated=1";
      }
    }
    return Promise.reject(err);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
